<template>
  <div class="dev-page">
    <div class="header-wrap app-flex-mid-center">
      <div class="image-wrap">
        <img src="../../../assets/area/dev1.png" class="bg" />
      </div>
      <div class="text-wrap">
        <base-text title="智控系统，一键触达" color="#fff" shadow-color="rgba(255,255,255, 0.3)" type="large"></base-text>
      </div>
    </div>

    <div class="main">
      <base-title title="自控系统" rich-title="system"></base-title>
      <div class="desc-cont">
        <div class="article-section">
          我司专注于提供工业自动化解决方案，为生产制造型企业提供智能制造系统的规划设计、系统集成、软件开发设计、系统（非标）定制、电气控制系统开发、设备现场安装调试、客户现场培训及专业售后服务等一系列业务。<br />
          集研发、生产、销售及安装调试于一体，与艾默生、霍尼韦尔等企业达成供应商合作体系，是一家专业的非标设备供应商，系统方案广泛应用于新能源电池、3C行业、烟草、核工业、物流及军工等行业。
        </div>
      </div>

      <base-title title="案例介绍" rich-title="case"></base-title>
      <div class="desc-tips">空压机站通用型智能控制系统</div>
      <div class="case-image case-1 app-flex-mid-center">
        <img src="../../../assets/area/dev2.png" class="case-icon" />
      </div>

      <div class="desc-cont">
        <div class="article-section">
          本系统适应于工厂能源站空压机集群控制，功能为实现对空压机、冷干机、电动阀门等部件设备进行集中控制，以及对各类阀门进行数据采集。<br />
          系统可兼容寿力、阿特拉斯、英格索兰等品牌及多种机型的通讯接口及数据格式，用户在使用时，仅需在软件界面勾选对应空压机设备型号，设置通讯站号、波特率参数等简单操作，即可完成系统配置。
        </div>
      </div>
      <div class="desc-tips">数据智能采集仪</div>
      <div class="case-image case-2 app-flex-mid-center">
        <img src="../../../assets/area/dev3.png" class="case-icon" />
      </div>
      <div class="desc-cont">
        <div class="article-section">
          数据智能采集仪功能为实现对工厂内部某区域、某环节的数据采集、监控及传输。
        </div>
      </div>
    </div>

    <base-foot></base-foot>
  </div>
</template>

<script>
import BaseText from '../components/BaseText.vue'
import BaseTitle from '../components/BaseTitle.vue'
import BaseFoot from '../components/BaseFoot.vue'

export default {
  name: 'DevPage',
  components: {
    BaseText,
    BaseTitle,
    BaseFoot
  },
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
.dev-page {
  width: 100%;
  background: linear-gradient(180deg, #d3e5f7 0%, #ffffff 20%);
  .header-wrap {
    position: relative;
    .image-wrap {
      width: 100%;
      height: 664px;
      overflow: hidden;
      .bg {
        height: 664px;
        width: auto;
      }
    }
    .text-wrap {
      position: absolute;
    }
  }

  .main {
    padding: 0px 260px 190px;
    .desc-cont {
      margin-top: 40px;
      .article-section {
        color: #4c4c4c;
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        line-height: 47px;
        text-indent: 48px;
        &:not(:last-child) {
          margin-bottom: 70px;
        }
      }
    }

    .desc-tips {
      margin: 70px 0px 20px;
      font-size: 30px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #000000;
      line-height: 43px;
    }
    .case-image {
      width: 100%;
      overflow: hidden;
      &.case-1 {
        height: 737px;
      }
      &.case-2 {
        height: 600px;
      }
      .case-icon {
        height: inherit;
        width: auto;
      }
    }
  }
}
</style>
